/**
 * 暂停页面上播放的视频
 */
export function pauseVideoPlayer() {
  const queue = [...window.app.$children];
  while (queue.length) {
    const componentInstance = queue.shift();
    if (componentInstance.$options.name === "VideoPlayer") {
      componentInstance.pausePlayer?.();
    }
    if (Array.isArray(componentInstance.$children) && componentInstance.$children.length) {
      queue.push(...componentInstance.$children);
    }
  }
}

